const serverConfig = {
    // baseURL: "http://192.168.1.9:8003/api/",
    baseURL: "https://jh.baoyj.net/website",

    // baseURLImg: "http://192.168.110.6:8080", // 请求基础地址,可根据环境自定义
    useTokenAuthorization: true, // 是否开启 token 认证
};
export default serverConfig;